import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, ReorderButton, CartButton } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { CountrySwitcherMenu } from '../../CountrySwitcherMenu/CountrySwitcherMenu.js';
import { LocaleSwitcherMenu } from '../../LocaleSwitcherMenu/LocaleSwitcherMenu.js';

function HeaderIconWithLabel({ icon  }) {
    const { getLabel  } = useIntl();
    if (!icon.parameters || !icon.parameters.icon) {
        return null;
    }
    const href = icon.link && icon.link.href ? icon.link.href : '#';
    const iconLabel = icon.parameters.icon === 'location' ? getLabel('stores.form.findStore.title') : icon.label;
    return /*#__PURE__*/ React.createElement("a", {
        className: "header-menu__icon",
        href: href,
        "aria-label": iconLabel
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon.parameters.icon
    }), /*#__PURE__*/ React.createElement("span", {
        className: "header-menu__label"
    }, iconLabel));
}
const HeaderMenu = ({ renderCartButton , showMultilingualComponents , availableLocales , myAccountButton , menuItems , toggleMobileSearch , countrySwitcherOptions , className , ordersUrl ,  })=>{
    const isAboveTabletPortrait = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const { getLabel  } = useIntl();
    const searchLabel = getLabel('common.header.search', {
        hideLabelKey: true
    });
    const { isReorderButtonEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React.createElement("nav", {
        className: classnames('header-menu', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "header-menu__icons"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "header-menu__search-button header-menu__icon",
        onClick: toggleMobileSearch,
        "aria-label": searchLabel
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "search"
    }), searchLabel && /*#__PURE__*/ React.createElement("span", {
        className: "header-menu__label"
    }, searchLabel)), isAboveTabletPortrait && /*#__PURE__*/ React.createElement(React.Fragment, null, countrySwitcherOptions && /*#__PURE__*/ React.createElement(CountrySwitcherMenu, {
        options: countrySwitcherOptions
    }), showMultilingualComponents && /*#__PURE__*/ React.createElement(LocaleSwitcherMenu, {
        availableLocales: availableLocales ? availableLocales : []
    }), myAccountButton, isReorderButtonEnabled && ordersUrl && /*#__PURE__*/ React.createElement(ReorderButton, {
        url: ordersUrl
    })), menuItems.map((item)=>item.parameters && item.parameters.icon !== 'cart' ? /*#__PURE__*/ React.createElement(HeaderIconWithLabel, {
            key: item.label,
            icon: item
        }) : renderCartButton ? renderCartButton(item) : /*#__PURE__*/ React.createElement(CartButton, {
            key: item.label,
            href: item.link && item.link.href,
            className: "header-menu__icon",
            label: item.label
        })
    )));
};
var HeaderMenu$1 = HeaderMenu;

export { HeaderIconWithLabel, HeaderMenu, HeaderMenu$1 as default };
//# sourceMappingURL=HeaderMenu.js.map
